import {
  faBicycle,
  faCircleNotch,
  faPen,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/layout";
// import PageHeader from "../../../components/pageHeader";
import { RootState } from "../../../redux/store";
import { API_BASE_URL } from "../../../utils/useFetch";
import ProfileNav from "../components/profileNav";
import AddAddressModal from "./components/addAddressModal";
import ConfirmDeleteAddressModal from "./components/confirmDeleteAddressModal";
import UpdateAddressModal from "./components/updateAddressModal";

const Addresses = () => {
  const [addresses, setAddresses] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((store: RootState) => store.user.userInfo);
  const [addAddressModalShow, setAddAddressModalShow] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState();
  const [deleteAddressModalShow, setDeleteAddressModalShow] = useState(false);
  const [updateAddressModalShow, setUpdateAddressModalShow] = useState(false);
  const fetchAddresses = useCallback(async () => {
    const _formData = new FormData();
    _formData.append("mobile", userData.mobile);
    _formData.append("code", userData.code);
    const response = await fetch(API_BASE_URL + "v2/get_addresses", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  }, [userData]);

  useEffect(() => {
    setIsLoading(true);
    fetchAddresses().then((response) => {
      setIsLoading(false);
      setAddresses(response);
    });
  }, [
    fetchAddresses,
    addAddressModalShow,
    deleteAddressModalShow,
    updateAddressModalShow,
  ]);

  const handleDeleteAddressClick = (address: any) => {
    setDeleteAddressModalShow(true);
    setSelectedAddress(address);
  };

  const handleUpdateAddressClick = (address: any) => {
    setUpdateAddressModalShow(true);
    setSelectedAddress(address);
  };

  return (
    <Layout>
      {/* <PageHeader /> */}
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='border-b border-solid'>
            <ProfileNav activeRoute={"/profile/addresses"} />
          </div>
          <div className='p-4'>
            {isLoading && (
              <div className='text-center p-4'>
                <div className='text-4xl text-gray-300'>
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className='rotate-animation'
                  />
                </div>
              </div>
            )}

            {!isLoading && addresses.length === 0 && (
              <div className='text-center p-4'>
                <div className='text-8xl text-gray-300'>
                  <FontAwesomeIcon icon={faBicycle} />
                </div>
                <div>آدرسی برای شما ثبت نشده است</div>
              </div>
            )}
            {!isLoading &&
              addresses.length > 0 &&
              addresses.map((address) => (
                <div className='p-2 border-b'>
                  <div className='flex items-center mb-2'>
                    <div className='flex-1 text-rose-900 font-bold'>
                      {address.region}
                    </div>
                    <div
                      onClick={() => handleUpdateAddressClick(address)}
                      className='text-gray-700 border rounded px-2 py-1 ml-2 text-center border-gray-700'
                    >
                      ویرایش <FontAwesomeIcon icon={faPen} />
                    </div>

                    <div
                      onClick={() => handleDeleteAddressClick(address)}
                      className='text-rose-600 border rounded px-2 py-1 text-center border-rose-600'
                    >
                      حذف <FontAwesomeIcon icon={faTrash} />
                    </div>
                  </div>

                  <div>{address.address}</div>
                </div>
              ))}

            <button
              className='border rounded border-rose-900 px-2 py-1 mt-2 text-rose-900 w-full'
              onClick={() => setAddAddressModalShow((prev) => !prev)}
            >
              <FontAwesomeIcon
                icon={faPlus}
                className='ml-1'
              />
              افزودن
            </button>
          </div>
        </div>
      </section>
      {addAddressModalShow && (
        <AddAddressModal
          showModal={() => setAddAddressModalShow((prev) => !prev)}
        />
      )}

      {deleteAddressModalShow && (
        <ConfirmDeleteAddressModal
          showModal={() => setDeleteAddressModalShow((prev) => !prev)}
          address={selectedAddress}
        />
      )}

      {updateAddressModalShow && (
        <UpdateAddressModal
          showModal={() => setUpdateAddressModalShow((prev) => !prev)}
          previousAddress={selectedAddress}
        />
      )}
    </Layout>
  );
};

export default Addresses;
